import React, { useState } from "react";
import useCompany from "../useCompany";
import { Info } from "lucide-react";
import { Button, Input, Select, Typography, InputNumber } from "antd";

const { Option } = Select;
const { Text } = Typography;

const PathPageEditor = ({ page, onSave, onCancel }) => {
    const [title, setTitle] = useState(page?.title || '');
    const [description, setDescription] = useState(page?.description || ''); // New state for description
    const [selectedPortfolios, setSelectedPortfolios] = useState(page?.portfolio_ids || []);
    const [maxSelect, setMaxSelect] = useState(page?.max_select || 1);
    const { mergedPortfolios } = useCompany();

    return (
        <div className="space-y-6 p-6 bg-white rounded-lg shadow">
            {/* Header Section */}
            <div className="bg-gray-50 p-4 rounded-lg">
                <div className="flex items-center gap-2 mb-2">
                    <Info size={20} className="text-gray-400" />
                    <Text className="text-gray-500">Configure how clients interact with this portfolio page</Text>
                </div>
            </div>

            {/* Form Fields */}
            <div className="space-y-6">
                <div>
                    <Text strong className="block mb-2">Page Title</Text>
                    <Input
                        value={title}
                        onChange={e => setTitle(e.target.value)}
                        placeholder="E.g., Risk-Based Portfolios"
                        className="h-12"
                    />
                </div>

                <div>
                    <Text strong className="block mb-2">Description</Text>
                    <Input.TextArea
                        value={description}
                        onChange={e => setDescription(e.target.value)}
                        placeholder="Provide a description for this page"
                        rows={4}
                    />
                </div>

                <div>
                    <Text strong className="block mb-2">Available Portfolios</Text>
                    <Select
                        mode="multiple"
                        style={{ width: '100%' }}
                        placeholder="Select portfolios to include"
                        value={selectedPortfolios}
                        onChange={setSelectedPortfolios}
                        className="h-12"
                        maxTagCount={3}
                        showArrow
                    >
                        {mergedPortfolios.map(portfolio => (
                            <Option key={portfolio.id} value={portfolio.id}>
                                {portfolio.name}
                            </Option>
                        ))}
                    </Select>
                </div>

                <div>
                    <Text strong className="block mb-2">Maximum Portfolio Selections</Text>
                    <InputNumber
                        min={1}
                        max={10}
                        value={maxSelect}
                        onChange={value => setMaxSelect(value)}
                        className="w-full"
                    />
                </div>
            </div>

            {/* Action Buttons */}
            <div className="flex justify-end gap-3 mt-8">
                <Button size="large" onClick={onCancel}>Cancel</Button>
                <Button
                    type="primary"
                    size="large"
                    onClick={() => onSave({
                        title,
                        description, // Include description in the saved data
                        portfolio_ids: selectedPortfolios,
                        max_select: maxSelect
                    })}
                    disabled={!title || selectedPortfolios.length === 0}
                >
                    {page ? 'Save Changes' : 'Create Page'}
                </Button>
            </div>
        </div>
    );
};

export default PathPageEditor;
